function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _object_without_properties(source, excluded) {
    if (source == null) return {};
    var target = _object_without_properties_loose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _object_without_properties_loose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from 'react';
import { faGripVertical, faMusic, faTrash } from '@fortawesome/free-solid-svg-icons';
import { useIntl } from 'react-intl';
import dayjs from 'dayjs';
import { ActionIcon, Anchor, Avatar, Badge, Box, Table as MantineTable, Portal, Text } from '@mantine/core';
import styles from './SongRow.module.scss';
import Icon, { IconSizes } from '../Icon';
import classNames from 'classnames';
export function SongDescription(param) {
    var song = param.song, className = param.className, isDragging = param.isDragging;
    return /*#__PURE__*/ _jsxs("div", {
        className: classNames(styles.songDescription, className, _define_property({}, styles.draggable, isDragging === false)),
        children: [
            isDragging != null || '_position' in song ? /*#__PURE__*/ _jsxs("div", {
                className: styles.songPrefixIcon,
                children: [
                    isDragging != null ? /*#__PURE__*/ _jsx(Icon, {
                        icon: faGripVertical,
                        size: IconSizes.SM,
                        className: styles.dragHandleIcon
                    }) : null,
                    '_position' in song ? /*#__PURE__*/ _jsx(Badge, {
                        className: styles.positionBadge,
                        children: song._position
                    }) : null
                ]
            }) : null,
            /*#__PURE__*/ _jsx(Avatar, {
                visibleFrom: "sm",
                src: song.track.artistAvatarUrl,
                size: "md",
                radius: "md",
                children: /*#__PURE__*/ _jsx(Icon, {
                    icon: faMusic,
                    size: IconSizes.SM
                })
            }),
            /*#__PURE__*/ _jsxs("div", {
                className: styles.songInfo,
                children: [
                    /*#__PURE__*/ _jsx(Anchor, {
                        className: styles.songTitle,
                        href: song.track.url,
                        children: song.track.title
                    }),
                    /*#__PURE__*/ _jsxs(Text, {
                        size: "sm",
                        className: styles.songDescriptionText,
                        children: [
                            song.track.artist,
                            " • ",
                            dayjs.duration(song.track.duration, 'seconds').format('mm:ss')
                        ]
                    })
                ]
            })
        ]
    });
}
function SongRow(_param) {
    var song = _param.song, snapshot = _param.snapshot, provided = _param.provided, portalRef = _param.portalRef, _param_isDraggable = _param.isDraggable, isDraggable = _param_isDraggable === void 0 ? false : _param_isDraggable, _param_showRequester = _param.showRequester, showRequester = _param_showRequester === void 0 ? true : _param_showRequester, onDelete = _param.onDelete, props = _object_without_properties(_param, [
        "song",
        "snapshot",
        "provided",
        "portalRef",
        "isDraggable",
        "showRequester",
        "onDelete"
    ]);
    var intl = useIntl();
    if (isDraggable && (portalRef === null || portalRef === void 0 ? void 0 : portalRef.current) != null && (snapshot === null || snapshot === void 0 ? void 0 : snapshot.isDragging) != null && snapshot.isDragging) {
        var _provided_innerRef, _provided_draggableProps, _provided_dragHandleProps;
        return /*#__PURE__*/ _jsx(Portal, {
            target: portalRef.current,
            children: /*#__PURE__*/ _jsx(Box, _object_spread_props(_object_spread({
                ref: (_provided_innerRef = provided === null || provided === void 0 ? void 0 : provided.innerRef) !== null && _provided_innerRef !== void 0 ? _provided_innerRef : undefined
            }, (_provided_draggableProps = provided === null || provided === void 0 ? void 0 : provided.draggableProps) !== null && _provided_draggableProps !== void 0 ? _provided_draggableProps : {}, (_provided_dragHandleProps = provided === null || provided === void 0 ? void 0 : provided.dragHandleProps) !== null && _provided_dragHandleProps !== void 0 ? _provided_dragHandleProps : {}, props), {
                children: /*#__PURE__*/ _jsx(SongDescription, {
                    isDragging: true,
                    className: styles.draggingSong,
                    song: song
                })
            }))
        });
    }
    var _provided_draggableProps1;
    return /*#__PURE__*/ _jsxs(MantineTable.Tr, _object_spread_props(_object_spread(_object_spread_props(_object_spread({}, props), {
        ref: provided === null || provided === void 0 ? void 0 : provided.innerRef
    }), (_provided_draggableProps1 = provided === null || provided === void 0 ? void 0 : provided.draggableProps) !== null && _provided_draggableProps1 !== void 0 ? _provided_draggableProps1 : {}, provided === null || provided === void 0 ? void 0 : provided.dragHandleProps), {
        children: [
            /*#__PURE__*/ _jsx(MantineTable.Td, {
                className: styles.songDescriptionColumn,
                children: /*#__PURE__*/ _jsx(SongDescription, {
                    song: song,
                    isDragging: isDraggable ? false : undefined
                })
            }),
            /*#__PURE__*/ _jsx(MantineTable.Td, {
                className: styles.requesterColumn,
                children: /*#__PURE__*/ _jsxs("div", {
                    className: styles.requesterContainer,
                    children: [
                        showRequester ? /*#__PURE__*/ _jsx(Text, {
                            children: 'user' in song ? song.user.displayName : intl.formatMessage({
                                id: "bv2dU7",
                                defaultMessage: [
                                    {
                                        type: 0,
                                        value: "Playlist"
                                    }
                                ]
                            })
                        }) : /*#__PURE__*/ _jsx(Text, {
                            children: dayjs(song.createdAt).format('MMM D, YYYY')
                        }),
                        /*#__PURE__*/ _jsx(Text, {
                            size: "sm",
                            className: styles.createdAt,
                            children: dayjs(song.createdAt).fromNow()
                        })
                    ]
                })
            }),
            onDelete !== undefined ? /*#__PURE__*/ _jsx(MantineTable.Td, {
                className: styles.actionsColumn,
                children: /*#__PURE__*/ _jsx(ActionIcon, {
                    size: "sm",
                    disabled: onDelete == null,
                    onClick: function() {
                        return onDelete === null || onDelete === void 0 ? void 0 : onDelete(song);
                    },
                    children: /*#__PURE__*/ _jsx(Icon, {
                        size: IconSizes.SM,
                        icon: faTrash
                    })
                })
            }) : null
        ]
    }));
}
export default SongRow;
